import {
  EmployeeSoftwareMembershipDocument,
  ItManagementCreateSoftwareSetupDocument,
  ItManagementCreateSoftwareSetupMutation,
  ItManagementCreateSoftwareSetupMutationVariables,
  ItManagementGetSoftwareDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateSoftwareSetup = () => {
  const [createSoftwareSetup, { loading }] = useMutation(ItManagementCreateSoftwareSetupDocument, {
    extractorFn: (data: ItManagementCreateSoftwareSetupMutation) =>
      data.itManagementMutations.createItmanagementSoftwareSetup,
  })

  return {
    create(variables: ItManagementCreateSoftwareSetupMutationVariables) {
      return createSoftwareSetup({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: ItManagementGetSoftwareDocument,
            variables: {},
          },
          {
            query: EmployeeSoftwareMembershipDocument,
            variables: {},
          },
        ],
      })
    },
    loading,
  }
}
